import { axiosInstance } from "./config";

export default {
  state: {
    nearby_locations: {},
  },
  mutations: {
    Set_nearby_locations(state, payload) {
      state.nearby_locations = payload;
    },
  },
  actions: {
    async Get_nearby_locations({ commit }, payload) {
      if (!payload) {
        payload = "";
      } else {
        payload = "/" + payload;
      }
      return await axiosInstance
        .get(`/nearby_locations${payload}`)
        .then(function (data) {
          commit("Set_nearby_locations", data?.data?.data);
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
    async Post_nearby_locations(commit, payload) {
      const formData = new FormData();
      formData.append("_method", "POST");
      for (const key in payload) {
        if (
          Object.prototype.hasOwnProperty.call(payload, key) &&
          payload[key] !== undefined
        ) {
          formData.append(key, payload[key]);
        }
      }

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      return await axiosInstance
        .post("/nearby_locations", formData, config)
        .then(function (data) {
          return data?.data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
    async Put_nearby_locations(commit, payload) {
      const formData = new FormData();
      formData.append("_method", "PUT");
      for (const key in payload) {
        if (
          Object.prototype.hasOwnProperty.call(payload, key) &&
          payload[key] !== undefined
        ) {
          formData.append(key, payload[key]);
        }
      }

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      return await axiosInstance
        .post("/nearby_locations/" + payload.id, formData, config)
        .then(function (data) {
          return data?.data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
    async Delete_nearby_locations(commit, payload) {
      return await axiosInstance
        .delete("/nearby_locations/" + payload.id)
        .then(function (data) {
          return data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
  },
  getters: {
    g_nearby_locations: (state) => state.nearby_locations,
  },
};
